export default "__VITE_ASSET__95Lc1z9j__"